import type { JSX } from 'react'
import type { IInputProps } from '../Input'

import { ButtonIconSizes } from 'atoms/Button'
import { TextBoxTypes } from 'atoms/TextBox'
import { Input } from '../Input'
import {
  InputActionButtonIndent,
  InputBorders,
  InputFontColors,
  InputFonts,
  InputNames,
  InputPaddings,
} from '../Input.h'

export interface IPhoneNumberInputProps extends IInputProps {}

export const PhoneNumberInput = ({
  name = InputNames.Phone,
  type = 'tel',
  placeholder = '',
  placeholderColor = InputFontColors.TEXT_ICON_SECONDARY,
  label = '',
  labelFont = TextBoxTypes.Caption4,
  iconSize = ButtonIconSizes.small,
  font = InputFonts.Body4,
  colorDefault = InputFontColors.TEXT_ICON_PRIMARY,
  required = true,
  paddings = InputPaddings.SIZE_20,
  borders = InputBorders.BORDER_10,
  inputLabelWidth = '100%',
  inputWrapperHeight = '40px',
  actionButtonIndent = InputActionButtonIndent.INDENT_60,
  ...rest
}: IPhoneNumberInputProps): JSX.Element => (
  <Input
    name={name}
    type={type}
    placeholder={placeholder}
    placeholderColor={placeholderColor}
    label={label}
    font={font}
    colorDefault={colorDefault}
    required={required}
    paddings={paddings}
    borders={borders}
    iconSize={iconSize}
    labelFont={labelFont}
    inputLabelWidth={inputLabelWidth}
    inputWrapperHeight={inputWrapperHeight}
    actionButtonIndent={actionButtonIndent}
    {...rest}
  />
)
